import React, { useCallback, useState } from 'react';
import ListaProductos from './ListaProductos';
import PersonalizarProducto from './PersonalizarProducto';
import PedidoCreado from './PedidoCreado';
import { TemaTienda, TiendaApi, tiendaApi, tiendaPublicaApi } from './tiendaUtils';
import './tienda.css';

const Contenido = ({ onPedidoCreado, onVerPedidos }) => {
  const [productoId, setProductoId] = useState(null);
  const [pedido, setPedido] = useState(null);
  const volver = useCallback(() => setProductoId(null), []);

  if (pedido) {
    return <PedidoCreado pedido={pedido} onVerPedidos={() => { setPedido(null); onVerPedidos?.(); }} />;
  }
  if (productoId) {
    return (
      <PersonalizarProducto
        productoId={productoId}
        onVolver={volver}
        onCreado={(p) => { setProductoId(null); setPedido(p); onPedidoCreado?.(); }}
      />
    );
  }
  return <ListaProductos onElegir={setProductoId} />;
};

export default function SeccionTienda({ claro = false, invitado = false, ...props }) {
  return (
    <TiendaApi.Provider value={invitado ? tiendaPublicaApi : tiendaApi}>
      <TemaTienda.Provider value={claro}>
        <div className={claro ? 'tienda-claro' : undefined} data-testid="tienda-tema">
          <Contenido {...props} />
        </div>
      </TemaTienda.Provider>
    </TiendaApi.Provider>
  );
}
